module.exports = __webpack_public_path__ + "90cffdacffd337dbe0a1d74938df1499.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/sign.svg
// module id = IYUt
// module chunks = 0